import { NgModule } from '@angular/core';

import { PageMetaResolver, provideConfig } from '@spartacus/core';

import { DpNewsDetailModule } from './news-detail/news-detail.module';
import { DpNewsListModule } from './news-list/news-list.module';
import { DpNewsOverviewPageMetaResolver, DpNewsPageMetaResolver } from './service/resolvers';

@NgModule({
  imports: [DpNewsDetailModule, DpNewsListModule],
  providers: [
    provideConfig({
      featureModules: {
        NewsCarousel: {
          cmsComponents: ['NewsCarouselComponent'],
          module: () => import('./news-carousel/news-carousel.module').then((m) => m.DpNewsCarouselModule),
        },

        AnnouncementCarousel: {
          cmsComponents: ['AnnouncementListComponent'],
          module: () =>
            import('./announcement-carousel/announcement-carousel.module').then((m) => m.DpAnnouncementCarouselModule),
        },
      },
    }),
    {
      provide: PageMetaResolver,
      useClass: DpNewsOverviewPageMetaResolver,
      multi: true,
    },
    {
      provide: PageMetaResolver,
      useClass: DpNewsPageMetaResolver,
      multi: true,
    },
  ],
})
export class DpNewsModule {}
